/**
 * Options {value,label} dos `<select>` de participante, derivadas dos enums reais
 * `@lume/shared` + labels PT-BR. Centraliza para reuso no add (drawer) e edit (card).
 */

import { BOND_SIDES, PERMISSION_SCOPES } from '@lume/shared';

import { scopeLabel, sideLabel } from './participants-labels';

export interface SelectOption {
  value: string;
  label: string;
}

export const PERMISSION_SCOPE_OPTIONS: readonly SelectOption[] = PERMISSION_SCOPES.map((s) => ({
  value: s,
  label: scopeLabel(s),
}));

// Lado inclui "nenhum" (side é opcional no DTO).
export const SIDE_OPTIONS: readonly SelectOption[] = [
  { value: '', label: 'Sem lado' },
  ...BOND_SIDES.map((s) => ({ value: s, label: sideLabel(s) })),
];
